import { Icon, Text, Pressable } from 'native-base';
import React, { FC, FunctionComponent } from 'react';
import { Platform, View } from 'react-native';
import {  Ionicons,  } from "@expo/vector-icons";

import { ElementBase, IElementBaseProps, useInitializeElement } from '..';

export const CheckElement: FunctionComponent<IElementBaseProps> = ({ ...props }) => {    
    const {
        itemsStore, element,
        payload, setPayload, errorList, setErrorList
    } = useInitializeElement(props);

      const Toggle = ()=>{
        return payload.value == true ? <Icon mx="2" size="lg" name="checkbox-outline" as={Ionicons} color={element.templateData?.textColor || "#000"}/> : <Icon mx="2" size="lg" name="square-outline" as={Ionicons} color={element.templateData?.textColor || "#000"} />;
    };

    const changeState = () => {
        if (props.forReview)
            return null;
        setPayload({ ...payload, value: (!payload.value == true) })
    }
    element.templateData.position = element.templateData.position ?? "left";    
    return <Pressable ref={ref=>props.setItemRef(ref,element.id)} width="100%" flex={Platform.OS=="web"?"1":null} _pressed={{bg: "secondary.600:alpha.20"}} _hover={{bg: "secondary.600:alpha.20"}} onPress={changeState}>
        <ElementBase boxStyle={{ justifyContent:"center", padding: 10,  flexDirection:"column"}}             
            errors={errorList} element={element} forReview={props.forReview} 
            hideTitleBar={true}>
            <View  style={{  alignItems: (element.templateData.position == "center" ? "center":"unset"), flexDirection: (element.templateData.position == "center" ? 'column-reverse' : (element.templateData.position == "right" ? 'row-reverse' : 'row')) }}>                
                <Toggle />
                <Text bold color={element.templateData?.textColor || "#000"}>{element.name ?? element.label} </Text>
            </View>
        </ElementBase></Pressable>
}